<template>
    <rkm-table
        :fields="fields"
        :filter="model.filter"
        :items="items"
        ref="RkmTable"
    >
        <template v-slot:filters>
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.unidade"
                        disabled
                        label="Unidade"
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.infraestrutura"
                        disabled
                        label="Local de atendimento"
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        label="Buscar"
                        placeholder="Digite para buscar"
                        v-model="model.filter"
                    />
                </rkm-col>
            </rkm-row>
        </template>

        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="edit(row.item)"
                authorize="update-painel-senha-opcao-entrada"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(row.item)"
                authorize="destroy-painel-senha-opcao-entrada"
                color="danger"
                small
                title="Excluir"
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({ lotacao: 'getLotacao' }),
        fields() {
            return [
                { key: 'setorNome', label: 'Setor', sortable: true },
                { key: 'moduloNome', label: 'Módulo', sortable: true },
                { key: 'opcaoEntradaNome', label: 'Nome', sortable: true },
                { key: 'opcaoEntradaSigla', label: 'Sigla', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
    },
    created() {
        this.repositories = {
            opcaoEntrada: this.getConectaSusRepository('painelSenha.opcaoEntrada')
        }
    },
    data: () => ({
        form: {
            unidade: [],
            infraestrutura: [],
        },
        items: [],
        model: {
            filter: null,
            unidadeId: null,
            infraestruturaId: null,
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = {
                with: [
                    'centroCusto.setor',
                    'modulo',
                ],
            }

            this.repositories.opcaoEntrada.index(request)
                .then(response => {
                    this.form.unidade =  [{
                        id: this.lotacao.infraestrutura.unidade.id,
                        nomeFantasia: this.lotacao.infraestrutura.unidade.nomeFantasia,
                    }]

                    this.form.infraestrutura = [{
                        id: this.lotacao.infraestrutura.id,
                        nome: this.lotacao.infraestrutura.nome,
                    }]

                    this.items = response.data

                    this.model.unidadeId = this.lotacao.infraestrutura.unidade.id
                    this.model.infraestruturaId = this.lotacao.infraestrutura.id
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(item) {
            this.$router.push({ name: 'painel-senha-opcao-entrada-edit', params: { id: item.id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.opcaoEntrada.destroy(item.id)
                .then(() => this.items.splice(this.items.findIndex(i => i.id === item.id), 1))

            this.showDeleteConfirmation('Deseja realmente excluir a opção de entrada?', destroy, this.handleError)
        },
    },
    mixins: [ error, repository ],
    mounted() {
        this.load()
    },
}
</script>